
import { MRT_ColumnFiltersState } from 'material-react-table';


export const getColumnFilterValue = (columnSearch: MRT_ColumnFiltersState | undefined, id: string): any | undefined =>
    columnSearch?.find(column => column?.id === id)?.value;

